import React from "react";
import Image from "next/image";
import LoadingIcon from "@public/Rainbow.gif";
import styles from "./bridge.module.scss";

const BridgeLoader = () => {
  return (
    <div className={styles.loadingIcon}>
      <Image src={LoadingIcon} alt="blessnet-loading" priority />
    </div>
  );
};

export default BridgeLoader;
